var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.4 486.4",
    style: {
      enableBackground: "new 0 0 486.4 486.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M378.5,464.4H107.9c-44.5,0-80.6-36.2-80.6-80.6V113.2c0-44.5,36.2-80.6,80.6-80.6h210.4 c20.1,0,39.3,7.4,54.2,20.9l60.1,54.5c16.8,15.2,26.5,37,26.5,59.7v216C459.1,428.2,422.9,464.4,378.5,464.4z M107.9,102.6 c-5.9,0-10.6,4.8-10.6,10.6v270.5c0,5.9,4.8,10.6,10.6,10.6h270.5c5.9,0,10.6-4.8,10.6-10.6v-216c0-3-1.3-5.9-3.5-7.9l-60.1-54.5 c-2-1.8-4.5-2.8-7.1-2.8H107.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    cx: 243.4,
    cy: 298.6,
    r: 74.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M271.3,200.6H140.8c-6.6,0-12-5.4-12-12v-43.5c0-6.6,5.4-12,12-12h130.5c6.6,0,12,5.4,12,12v43.5 C283.3,195.2,277.9,200.6,271.3,200.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSave);
export default __webpack_public_path__ + "static/media/button-save.33f248305226c2eb96b8062f7094097d.svg";
export { ForwardRef as ReactComponent };